import { sendRequest } from "../libs/axiosConfig";

export const getPricingApi = async () => {
  const res = await sendRequest({
    url: `/api/v1/pricing`,
  });
  return res;
};